(function ($) {
    $(document).ready(function () {
        var dashboardSelect = $('#DashboardId'),
            widgetSelectsContainer = $('#widget-selects'),
            widgetSelects = widgetSelectsContainer.find('select').removeClass('hidden').detach();

        dashboardSelect.change(function () {
            var selection = $(this).find(':selected').val();

            var tableAttributeSelect = widgetSelects.filter('[data-dashboard-id=' + selection + ']');
            widgetSelectsContainer.find('select').remove();
            widgetSelectsContainer.append(tableAttributeSelect);
        });

        dashboardSelect.trigger('change', true);
    });
})(jQuery);